export default __webpack_public_path__ + "static/media/desktop_ellipse_1.a95e85fa.svg";